// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ExpertisePage from "../pages/Expertise/Expertise";
const __wvcRoutePaths = ["/ExpertisePage", "/expertise"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["contact", "contactpage", "expertise", "expertisepage", "home", "homepage", "post", "projects", "projectspage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<ExpertisePage />} />
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ExpertisePage />} />
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
